const sizes = {
    small: 2,
    xsmall: 4,
    xxsmall: 8,
    xxxsmall: 12,
    medium: 16,
    xmedium: 20,
    xxmedium: 24,
    xxxmedium: 28,
    large: 32,
    xlarge: 36,
    xxlarge: 40,
    xxxlarge: 44,
    titlle: 48,
    xxtitle: 52,
    xsixty: 60,
    xtitle: 72,
    spacesFull: 78,
    xspacesFull: 86,
    header: 112,
    navigation: 118,
    xxspacesFull: 120,
    calltoaction: 130,
}

export const spaces = Object.values(sizes).map((sizes) => `${sizes}px`) as never

Object.keys(sizes).forEach((key, index) => {
    spaces[key] = spaces[index]
    return {
        [key]: index,
    }
})
